import {
    ORDER_EXPORT_LOADING,
    ORDER_EXPORT_ERROR,
    ORDER_EXPORT_GET_LAYOUTS,
    ORDER_EXPORT_SET_LAYOUTS,
    ORDER_EXPORT_UPDATE_LAYOUT_BY_ID,
    ORDER_EXPORT_DELETE_LAYOUT_BY_ID,
    ORDER_EXPORT_GET_LAYOUT_BY_ID,
    ORDER_EXPORT_GET_FIELDS
} from "api/menu/master-files/order-export-layouts/actions";

const initialState = {
    loading: false,
    errors: [],

    orderLayouts: [],
    singleOrderLayout: {},
    orderLayoutsFields: []
};

let layouts;
let index;

export default function(state = initialState, action) {
    switch (action.type) {
        case ORDER_EXPORT_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case ORDER_EXPORT_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case ORDER_EXPORT_GET_LAYOUTS:
            return {
                ...state,
                loading: false,
                orderLayouts: action.payload
            };
        case ORDER_EXPORT_SET_LAYOUTS:
            return {
                ...state,
                loading: false,
                orderLayouts: [...state.orderLayouts, action.payload]
            };
        case ORDER_EXPORT_UPDATE_LAYOUT_BY_ID:
            layouts = [...state.orderLayouts];
            index = state.orderLayouts.findIndex(item =>
                item.orderExportLayoutId === action.payload.orderExportLayoutId);
            layouts[index] = action.payload;
            return {
                ...state,
                loading: false,
                orderLayouts: layouts
            };
        case ORDER_EXPORT_DELETE_LAYOUT_BY_ID:
            layouts = [...state.orderLayouts];
            index = state.orderLayouts
                .findIndex(item => item.orderExportLayoutId === action.payload.id);
            layouts.splice(index, 1);
            return {
                ...state,
                loading: false,
                orderLayouts: layouts
            };
        case ORDER_EXPORT_GET_LAYOUT_BY_ID:
            return {
                ...state,
                loading: false,
                singleOrderLayout: action.payload
            };
        case ORDER_EXPORT_GET_FIELDS:
            return {
                ...state,
                loading: false,
                orderLayoutsFields: action.payload
            };
        default:
            return state;
    }
}
